import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ImportProductsArgsAction } from "../../../api";

export interface ImportActionListProps {
  value?: ImportProductsArgsAction;
  onChange?: (value: ImportProductsArgsAction) => void;
}

export const ImportActionList = (props: ImportActionListProps) => {
  const { value: method, onChange } = props;

  const handleChange = (value: string) => {
    if (onChange) onChange(value as ImportProductsArgsAction);
  };

  return (
    <FormControl>
      <InputLabel id="import-action-list-label">Unmatched products action</InputLabel>
      <Select labelId="import-action-list-label" label="Unmatched products action" value={method || ImportProductsArgsAction.None} onChange={(e) => handleChange(e.target.value)}>
        {Object.keys(ImportProductsArgsAction).map((item) => {
          return (
            <MenuItem value={item} key={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
